<h1 mat-dialog-title class="edit-form-title">{{title}}</h1>
<mat-dialog-content class="edit-form-content">
    <form class="edit-form" [formGroup]="editForm" (ngSubmit)="save()">
        <div class="content-container">
            <mat-form-field class="code">
                <mat-label>Code</mat-label>
                <input matInput formControlName="code" maxlength="50">
                <mat-error *ngIf="editForm.controls['code'].hasError('maxlength')">Maximum length is 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="name">
                <mat-label>Name</mat-label>
                <input matInput formControlName="name">
                <mat-error *ngIf="editForm.controls['name'].hasError('maxlength')">Maximum length is 50.</mat-error>
            </mat-form-field>
            <mat-form-field class="reward_category_name">
                <mat-label>Reward category name</mat-label>
                <mat-select formControlName="reward_category_name">
                  <mat-option value="option1">Option 1</mat-option>
                  <mat-option value="option2">Option 2</mat-option>
                  <mat-option value="option3">Option 3</mat-option>
                </mat-select>
                <mat-error *ngIf="editForm.controls['reward_category_name'].hasError('maxlength')">Maximum length is 200.</mat-error>
              </mat-form-field>
            <mat-form-field class="can_stack">
                <mat-label>Stackable</mat-label>
                <input matInput formControlName="can_stack">
                <mat-error *ngIf="editForm.controls['can_stack'].hasError('maxlength')">Maximum length is 50.</mat-error>
            </mat-form-field>
            <div class="status-toggle-container">
                <span class="status-toggle-title">Active</span>
                <mat-slide-toggle formControlName="is_active" class="status-toggle"></mat-slide-toggle>
            </div>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end" class="footer">
    <button mat-raised-button color="primary" (click)="save()">Save</button>
    <button mat-button (click)="cancel()">Cancel</button>
</mat-dialog-actions>